import React from 'react'

import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import "./styles.css"
const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'>Harshvardhan Ravishanker</a>
      <ul className="permalinks">
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#skills">Technology</a></li>
        <li><a href="#projects">Projects</a></li>
        <li><a href="#publications">Publication</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://www.linkedin.com/in/harsh2338"><BsLinkedin/></a>
        <a href="https://github.com/harsh2338"><FaGithub/></a>      
      </div>
    </footer>
  )
}

export default Footer